module.exports = __webpack_public_path__ + "static/media/Green_Coffee_Peeling_retina_kosik.2f91d4ef.jpg";